import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import RangePlugin from "flatpickr/dist/plugins/rangePlugin"
import { French } from "flatpickr/dist/l10n/fr.js"
import { German } from "flatpickr/dist/l10n/de.js"
import { Polish } from "flatpickr/dist/l10n/pl.js"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import { Czech } from "flatpickr/dist/l10n/cs.js"
import { Slovak } from "flatpickr/dist/l10n/sk.js"
import { Ukrainian } from "flatpickr/dist/l10n/uk.js"
const debounce = require("lodash/debounce")

const datepickerLocales = {
  cs: Czech,
  de: German,
  es: Spanish,
  fr: French,
  pl: Polish,
  sk: Slovak,
  uk: Ukrainian,
}
export default class extends Controller {
  static values = {
    format: { type: String, default: "Y-m-d" },
    locale: { type: String, default: "pl" },
    range: { type: Boolean, default: false },
    enableTime: { type: Boolean, default: false },
    endInput: String,
    lazy: { type: Boolean, default: false }
  }

  connect() {
    if (this.lazyValue) { this.bindLazyInit() } else { this.initPicker() }
  }

  // Wariant lazy: flatpickr powstaje dopiero przy pierwszej interakcji z polem. Potrzebny na
  // listach, gdzie pól daty jest tyle, ile wierszy - flatpickr buduje cały kalendarz w DOM już
  // przy inicjalizacji, więc 20 pól to 20 kalendarzy, z których zwykle otwiera się jeden.
  // Nasłuch na zdarzeniach POPRZEDZAJĄCYCH otwarcie (hover, dotknięcie, focus), żeby picker
  // był gotowy, zanim user kliknie.
  bindLazyInit() {
    this.lazyInitHandler = this.lazyInitHandler || this.handleLazyInit.bind(this)
    this.element.addEventListener("pointerenter", this.lazyInitHandler)
    this.element.addEventListener("focusin", this.lazyInitHandler)
    this.element.addEventListener("touchstart", this.lazyInitHandler, { passive: true })
  }

  unbindLazyInit() {
    if (!this.lazyInitHandler) { return }

    this.element.removeEventListener("pointerenter", this.lazyInitHandler)
    this.element.removeEventListener("focusin", this.lazyInitHandler)
    this.element.removeEventListener("touchstart", this.lazyInitHandler)
  }

  // Przy focusie musimy otworzyć kalendarz sami: flatpickr otwiera się właśnie na focusie,
  // a tego zdarzenia już nie dostanie - powstał chwilę po nim. Hover i dotknięcie tylko
  // przygotowują picker, bo focus dopiero nadejdzie i otworzy kalendarz normalnie.
  handleLazyInit(event) {
    if (this.picker) { return }

    this.unbindLazyInit()
    this.initPicker()
    if (event?.type === "focusin") { this.picker.open() }
  }

  initPicker() {
    console.log("picker")

    const options = {
      locale: {
        ...this.locale,
        firstDayOfWeek: 1
      },
      dateFormat: this.formatValue,
      allowInput: true
    }

    if (this.enableTimeValue) {
      options.enableTime = true
      options.time_24hr = true
    }

    if (this.rangeValue) {
      options.plugins = [new RangePlugin({ input: this.endInputValue })]
    }

    this.picker = flatpickr(this.element, options)

    const handleInput = debounce(() => {
      const val = this.element.value.trim()
      try {
        const parsed = this.picker.parseDate(val, this.formatValue)

        if (parsed instanceof Date && !isNaN(parsed)) {
          const formatted = this.picker.formatDate(parsed, this.formatValue)
          if (val === formatted) {
            this.picker.setDate(parsed, true)
          }
        }
      } catch (_err) {
      }
    }, 500)

    this.element.addEventListener("keyup", handleInput)
  }

  disconnect() {
    this.unbindLazyInit()

    if (this.picker) {
      this.picker.destroy()
      this.picker = null
    }
  }

  get locale() {
    if (this.hasLocaleValue) {
      return datepickerLocales[this.localeValue] || {}
    }

    return null
  }
}
